






import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Utilities as utils} from '@/shared/utilities'

@Component
export default class AuditInfoComponent extends Vue {
    @Prop() auditInfo: any;

    get createdDate() {
      return utils.dateFormat(this.auditInfo.createdDate)
    }
    get updatedDate() {
      return utils.dateFormat(this.auditInfo.updatedDate)
    }
}
